<template>
    <base-button type="primary" size="sm" @click="handleClick">
        <i class="fa fa-arrow-left fa-fw"></i>Volver
    </base-button>
</template>
<script>
export default {
    name: "goback-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>